module.exports = __webpack_public_path__ + "img/news-slider1-zh.185c44c8.jpg";